/* Import statements have been left out for code brevity */
import React from "react";
import BackButton from "./BackButton";
import "../css/School.css";
import WaterTable from "./tables/WaterTable";
import LocatorMap from "./LeafletMap";
import StandardTable from "./tables/StandardTable";
import AsbestosTable from "./tables/Asbestos/AsbestosTable";
import FoodTable from "./tables/food/foodtable";

function reportText(reports) {
  if (reports === 1) {
    return "report";
  } else {
    return "reports";
  }
}

function gotosection(name) {
  const element = document.getElementById(name);
  let count = element.offsetTop - 100;
  if (element) window.scrollTo({ top: count });
}

const SchoolInfo = ({
  match,
  data,
  reports,
  water,
  asbestos,
  asbestos2020,
  food
}) => {
  var school = data.find(
    p => p["Link with ULCS"] === Number(match.params.schoolId)
  );

  function getBucket(reports, type) {
    var rate = (reports / school["2017-18 Total Enrolled"]) * 100;

    if (type === "lead") {
      return rate > 4.1
        ? "tier1"
        : rate > 1.1
        ? "tier2"
        : rate > 0.01
        ? "tier3"
        : "tier4";
    }
    if (type === "asbestos") {
      return rate > 3.02
        ? "tier1"
        : rate > 1.24
        ? "tier2"
        : rate > 0.01
        ? "tier3"
        : "tier4";
    }
    if (type === "asthma") {
      return rate > 6.2
        ? "tier1"
        : rate > 1.85
        ? "tier2"
        : rate > 0.01
        ? "tier3"
        : "tier4";
    }
    if (type === "leadwater") {
      return rate > 0.63
        ? "tier1"
        : rate > 0.262
        ? "tier2"
        : rate > 0.01
        ? "tier3"
        : "tier4";
    }
  }

  var schoolData;

  if (school) {
    var sortedReports = reports.filter(
      r => r["UCLS"] === Number(match.params.schoolId)
    );
    var leadReports = sortedReports.filter(
      q => q["Category"] === "Damaged paint and plaster"
    );
    var asbestosReports = sortedReports.filter(
      q => q["Category"] === "Asbestos"
    );
    var asthmaReports = sortedReports.filter(
      q =>
        (q["Category"] === "Air quality, allergies and asthma") |
        (q["Category"] === "Mold, leaks and moisture") |
        (q["Category"] === "Rodents and insects")
    );
    var waterReports = water.filter(
      r => r["key"] === Number(match.params.schoolId)
    );
    var asbestos2 = asbestos.filter(
      r => r["key"] === Number(match.params.schoolId)
    );

    var asbestos2020Reports = asbestos2020.filter(
      r => r["key"] === Number(match.params.schoolId)
    );

    function filterByULCS(item) {
      return (
        isNaN(item.ULCS_f) === false &&
        Number(item.ULCS_f) === Number(match.params.schoolId)
      );
    }

    var foodReports = food.filter(filterByULCS);

    var coordinates = school["GPS Location"];

    console.log(school, asbestos2020Reports);

    schoolData = (
      <div className="schoolinfo">
        <div className="schoolPadding flexordering">
          <div className="custom-social-share">
            <div className="share-label">Share school</div>
            <a
              href={
                "http://www.facebook.com/sharer.php?u=https%3A//media.inquirer.com/toxic-city/lead-poisoning-paint-asbestos-mold-asthma-philadelphia-schools-map-search-tool.html%23" +
                match.url
              }
              target="_blank"
              aria-label="share-facebook"
              className="shareBtn faceb"
            >
              &zwnj;
            </a>
            <a
              href={
                "https://twitter.com/intent/tweet?url=https%3A%2F%2Fmedia.inquirer.com%2Ftoxic-city%2Flead-poisoning-paint-asbestos-mold-asthma-philadelphia-schools-map-search-tool.html%23" +
                match.url.replace(/\//g, "%2F") +
                "&text=Toxic%20City%3A%20School%20Checkup%20%7C%20" +
                school["Publication Name"].replace(/\s/g, "%20")
              }
              target="_blank"
              aria-label="share-twitter"
              className="shareBtn twit"
            >
              &zwnj;
            </a>
            <a
              href={
                "mailto:?subject=Toxic City: School Checkup - " +
                school["Publication Name"] +
                "&body=See the tool here: https%3A//media.inquirer.com/toxic-city/lead-poisoning-paint-asbestos-mold-asthma-philadelphia-schools-map-search-tool.html%23" +
                match.url
              }
              target="_blank"
              aria-label="share-email"
              className="shareBtn email"
            >
              &zwnj;
            </a>
          </div>
          <div className="sidebarsection halfhalf flipped">
            <div className="mainsection">
              {school["Has PDF 1819"] ? (
                <div className="has-update">
                  <strong>NEW</strong>—2018-19 EPA-required three year
                  inspection
                </div>
              ) : (
                <div className="has-update no-update">
                  2018-19 EPA-required three year inspection not yet published
                </div>
              )}
              {school["Publication Name"] === "The Workshop School" ? (
                <h1>{school["Publication Name"]}</h1>
              ) : (
                <h1>
                  {school["Publication Name"].replace(/ School\s*$/m, "")}
                </h1>
              )}

              <div className="infosection">
                <div className="infotext">
                  {school["Street Address"]}
                  <br />
                  {school["Phone Number"]}
                </div>
                <div className="infotext">
                  <strong>School built</strong>:{" "}
                  {school["Year Built"]
                    ? school["Year Built"]
                    : "Not available"}{" "}
                  <br />
                  <strong>School Level</strong>: {school["On Dist web site"]}
                  <br />
                  {school["Enroll19_20"] ? (
                    <span>
                      <strong>2019-20 Enrollment</strong>:{" "}
                      {school["Enroll19_20"]} students
                    </span>
                  ) : (
                    <span>
                      <strong>2017-18 Enrollment</strong>:{" "}
                      {school["2017-18 Total Enrolled"]} students
                    </span>
                  )}
                </div>

                {school["Year Built"] > 1978 ? (
                  <div className="infotext">
                    <strong>
                      This school was built after 1978, the year lead paint was
                      outlawed in the United States.
                    </strong>
                  </div>
                ) : (
                  ""
                )}
                {school["DocCloud"] && (
                  <div className="infotext">
                    <a href={school["DocCloud"]} target="_blank">
                      <i className="fas fa-file-alt"></i> Explore district
                      documents here
                    </a>
                  </div>
                )}
                {school["Story links"] && (
                  <div className="infotext">
                    <span className="label">Read our coverage:</span>

                    {school["Story links"].split(",").map((link, i) => (
                      <a href={link} target="_blank">
                        {school["Story Titles"].split(",")[i]}{" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="leftside">
              <LocatorMap location={coordinates} />
            </div>
          </div>

          <div className="datasection">
            <strong>Rate of reports per 100 students:</strong>
            <div className="legend flexFullWidth">
              <div className="legenditem">
                <span className="tierdot tier4"></span>No reports
              </div>
              <div className="legenditem">
                <span className="tierdot tier3"></span>Below average
              </div>
              <div className="legenditem">
                <span className="tierdot tier2"></span>Average
              </div>
              <div className="legenditem">
                <span className="tierdot tier1"></span>Above average
              </div>
            </div>
            <div className="data-item-wrapper">
              <div
                className={"dataitem " + getBucket(leadReports.length, "lead")}
                onClick={() => {
                  gotosection("leadpaintdust");
                }}
              >
                <div className="infotitle">Lead paint residue </div>
                <div className="infotext">
                  <div className="reports">
                    {leadReports.length}
                    <span> {reportText(leadReports.length)}</span>
                  </div>
                </div>
              </div>
              <div
                className={`dataitem ${
                  school["Has PDF 1819"]
                    ? getBucket(asbestos2020Reports.length, "asbestos")
                    : getBucket(
                        asbestos2.length + asbestosReports.length,
                        "asbestos"
                      )
                } ${school["Has PDF 1819"] ? "new-data" : ""}`}
                onClick={() => {
                  gotosection("asbestos");
                }}
              >
                <div className="infotitle">Damaged asbestos</div>
                <div className="infotext">
                  <div className="reports">
                    {school["Has PDF 1819"]
                      ? asbestos2020Reports.length
                      : asbestos2.length + asbestosReports.length}

                    <span>
                      {" "}
                      {asbestos2020Reports.length > 0
                        ? reportText(asbestos2020Reports.length)
                        : reportText(asbestos2.length + asbestosReports.length)}
                    </span>
                  </div>
                </div>
              </div>
              <div
                className={
                  "dataitem " +
                  getBucket(asthmaReports.length + foodReports.length, "asthma")
                }
                onClick={() => {
                  gotosection("asthmatriggers");
                }}
              >
                <div className="infotitle ">Asthma triggers </div>
                <div className="infotext">
                  <div className="reports">
                    {asthmaReports.length + foodReports.length}
                    <span>
                      {" "}
                      {reportText(asthmaReports.length + foodReports.length)}
                    </span>
                  </div>
                </div>
              </div>
              <div
                className={
                  "dataitem " + getBucket(waterReports.length, "leadwater")
                }
                onClick={() => {
                  gotosection("leadinwater");
                }}
              >
                <div className="infotitle ">Lead in drinking water</div>
                <div className="infotext">
                  <div className="reports">
                    {waterReports.length}
                    <span> {reportText(waterReports.length)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" detailsection schoolPadding lead" id="leadpaintdust">
          <div
            className={
              "tierHeader " + getBucket(leadReports.length, "lead") + "Top"
            }
          />
          <h2>Lead paint residue</h2>
          <p>
            Lead dust and residue from peeling paint can cause permanent
            neurological damage, including intelligence loss, hyperactivity and
            behavioral problems, especially in young children. The district
            assumes paint in schools built before 1978 contain lead. The
            deficiencies listed assume the presence of lead paint, based on
            description and age of the school.
          </p>

          {leadReports.length > 0 ? (
            <StandardTable reports={leadReports} classname="table-lead" />
          ) : (
            <div className="noreports">No reports of lead paint residue.</div>
          )}
        </div>

        <div className=" detailsection schoolPadding asbestos" id="asbestos">
          <div
            className={
              "tierHeader " +
              getBucket(asbestos2.length + asbestosReports.length, "asbestos") +
              "Top"
            }
          />
          <h2>Damaged asbestos</h2>
          <p>
            Until 1980, asbestos was widely used in schools for insulation,
            soundproofing, and floor and ceiling tiles. When inhaled over time,
            these sharp, invisible fibers can cause asbestosis, lung cancer,
            mesothelioma, and other serious illnesses. School districts are
            required to have a plan to abate or monitor asbestos that becomes
            damaged.
          </p>

          {school["Has PDF 1819"] && asbestos2020Reports.length > 0 ? (
            <div className="new-reports">
              <div className="tableTitle">
                <strong>NEW</strong>—EPA-required three year inspection, 2018-19
              </div>
              <AsbestosTable
                reports={asbestos2020Reports}
                classname="table-asbestos"
              />
            </div>
          ) : (
            ""
          )}

          {school["Has PDF 1819"] && asbestos2020Reports.length === 0 ? (
            <div className="new-reports">
              <div className="tableTitle">
                <strong>NEW</strong>—EPA-required three year inspection, 2018-19
              </div>
              <div className="noreports">
                No reports of damaged asbestos in 2018-19.
              </div>
              <hr />
            </div>
          ) : (
            ""
          )}

          {(() => {
            if (asbestos2.length === 0 && asbestosReports.length === 0) {
              return (
                <div className="noreports">
                  No reports of damaged asbestos in 2015-16.
                </div>
              );
            } else {
              return (
                <div>
                  <div className="tableTitle">
                    EPA-required three year inspection, 2015-16
                  </div>
                  <AsbestosTable
                    reports={asbestos2}
                    classname="table-asbestos"
                  />
                  <StandardTable
                    reports={asbestosReports}
                    classname="table-asbestos"
                  />
                </div>
              );
            }
          })()}
        </div>

        <div
          className=" detailsection schoolPadding asthma"
          id="asthmatriggers"
        >
          <div
            className={
              "tierHeader " +
              getBucket(asthmaReports.length + foodReports.length, "asthma") +
              "Top"
            }
          />
          <h2>Asthma Triggers</h2>

          <p>
            Mold, chronic moisture, dust, rodents dropping and urine, and
            cockroach droppings and shedding can trigger attacks. Children face
            heightened risk for asthma inside dirty, poorly ventilated schools.
            A severe attack, without medical intervention, can be fatal.
          </p>

          {(() => {
            if (asthmaReports.length === 0 && foodReports.length === 0) {
              return (
                <div className="noreports">
                  No asthma-related reports found.
                </div>
              );
            } else {
              return (
                <div>
                  <StandardTable
                    reports={asthmaReports}
                    classname="table-asthma"
                  />

                  <FoodTable reports={foodReports} classname="table-food" />
                </div>
              );
            }
          })()}
        </div>

        <div className=" detailsection schoolPadding water" id="leadinwater">
          <div
            className={
              "tierHeader " +
              getBucket(waterReports.length, "leadwater") +
              "Top"
            }
          />
          <h2>Lead in drinking water</h2>
          <p>
            Schools built before 1986 are more likely to have pipes, fixtures
            and soldering that contains lead, which can leech into the water
            supply. The EPA says the concentration of lead in drinking water
            should not exceed an "action level" of 15 parts per billion (ppb).
            The district follows a lower threshold, 10 ppb. Ingesting slight
            amounts of lead can cause loss of IQ and behavioral problems in
            children.
          </p>
          <WaterTable reports={waterReports} />
        </div>
      </div>
    );
  } else {
    schoolData = <h2>Please select a school.</h2>;
  }
  return (
    <div>
      <BackButton />
      <div>{schoolData}</div>
    </div>
  );
};

export default SchoolInfo;



// WEBPACK FOOTER //
// ./src/components/SchoolInfo.js